<template>
	<span
		class="event-list-item-status-badge"
		:class="[`-${status}`]"
	>
		{{ label }}
	</span>
</template>

<script>
import { EVENT_STATUS } from '@shared/utils/eventUtils';

export default {
	name:  'EventListItemStatusBadge',
	props: {
		status: {
			type:      String,
			required:  true,
			validator: status => Object.values(EVENT_STATUS).includes(status),
		},
	},
	computed: {
		label() {
			switch (this.status) {
			case EVENT_STATUS.LIVE:
				return this.$I18n.trans('event.status.live');
			case EVENT_STATUS.REPLAY:
				return this.$I18n.trans_choice('commons.replay', 1);
			default:
				return this.$I18n.trans('event_center.status.upcoming');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-status-badge {
	@include font(primary, medium, normal, fs-80);
	display: inline-flex;
	min-height: $sp5;
	padding-left: $sp3-5;
	padding-right: $sp3-5;
	border-radius: $border-radius--full;
	background-color: var(--color-grey-800);
	color: var(--color-grey-100);
	align-items: center;
	line-height: 1;
	white-space: nowrap;

	&.-live {
		background-color: var(--color-red);
		color: var(--color-white);
	}

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		background-color: var(--color-grey-800);
		color: var(--color-grey-200);
	}

	body.-t-light &.-live { // stylelint-disable-line selector-no-qualifying-type
		background-color: var(--color-red);
		color: var(--color-white);
	}
}
</style>
